import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { EfficiencyMicroFrontend } from '@allie/mfe';
import { env } from '@env';
import { isMobile, isSmartTV, isTablet } from '../../helpers/utils';
import { AppContext, AuthContext, UtilsContext } from '../../context';
import { CommonPageProps } from '../../App.types';
import { useAppTranslations } from '../../hooks';

export const EfficiencyPage: React.FC<CommonPageProps> = ({ basePath, openLogin }) => {
  const { permissions, loggedUser, tryGuestLogin } = useContext(AuthContext);
  const { lang } = useContext(AppContext);
  const { path = 'stations' } = useParams<{ path: EfficiencyPages }>();
  const { tracker, company } = useContext(UtilsContext);
  const { LOADING_MESSAGES } = useAppTranslations();

  type EfficiencyPages =
    | 'stations'
    | 'shift'
    | 'factory'
    | 'processing-variables'
    | 'action/assign-stop-reason';

  const loadingMessage = LOADING_MESSAGES['EFFICIENCY'][path];

  return (
    company && (
      <EfficiencyMicroFrontend
        entryPointUrl={env.REACT_APP_EFFICIENCY_ENTRYPOINT || ''}
        basePath={basePath}
        permissions={permissions}
        tryGuestLogin={tryGuestLogin}
        loggedUser={loggedUser}
        loadingMessage={loadingMessage}
        openLogin={openLogin}
        isMobile={isMobile}
        isTablet={isTablet}
        isSmartTV={isSmartTV}
        lang={lang}
        tracker={tracker}
        company={company}
      />
    )
  );
};
